import Typography from '@app/components/atoms/Typography';
import styled from 'styled-components';
import { deviceSizes } from '@app/config/devices';
export var ImageContainer = styled.div.withConfig({
  displayName: "style__ImageContainer",
  componentId: "sc-jsuxgb-0"
})(["margin-right:1rem;margin-bottom:1rem;display:flex;width:30%;height:130px;align-items:center;justify-content:center;img{border-radius:6px;width:100%;height:100%;}position:relative;@media (max-width:", "){margin-right:10px;margin-bottom:10px;}@media (max-width:", "){margin-right:5px;margin-bottom:5px;}@media (max-width:", "){height:90px;}"], deviceSizes.tablet, deviceSizes.sm, deviceSizes.mobileL);
export var LightboxContainer = styled.div.withConfig({
  displayName: "style__LightboxContainer",
  componentId: "sc-jsuxgb-1"
})(["display:flex;flex-wrap:wrap;flex-direction:row;"]);
export var StyledTypography = styled(Typography).withConfig({
  displayName: "style__StyledTypography",
  componentId: "sc-jsuxgb-2"
})(["&&{position:absolute;color:white;font-weight:bold;cursor:pointer;&:hover{text-decoration:underline;}}"]);
export var StyledIconBox = styled.div.withConfig({
  displayName: "style__StyledIconBox",
  componentId: "sc-jsuxgb-3"
})(["position:absolute;bottom:0;right:10px;svg:hover{fill:", ";cursor:pointer;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.primary.main;
});